import { render, staticRenderFns } from "./pre-invest.vue?vue&type=template&id=05abdbfc&scoped=true"
import script from "./pre-invest.vue?vue&type=script&lang=js"
export * from "./pre-invest.vue?vue&type=script&lang=js"
import style0 from "./pre-invest.vue?vue&type=style&index=0&id=05abdbfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05abdbfc",
  null
  
)

export default component.exports